import {Pipe, PipeTransform} from '@angular/core';
import {DateUtils} from 'app/core/components/common/date-utils';

@Pipe({name: 'isoToDate'})
export class ISOToDatePipe implements PipeTransform {

    constructor() { }

    transform(value: string, args?: string): string {
        return DateUtils.isoToDate(value, args);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/iso-to-date.pipe.ts